import "./ProductGrid.css";
import ProductCard from "./ProductCard";

function ProductCardSkeleton() {
  return (
    <div className="adc-card adc-card--skeleton" aria-hidden="true">
      <div className="adc-card-image">
        <div className="adc-skel-media" />
        <span className="adc-stock-badge in adc-skel-badge">Cargando</span>
      </div>

      <div className="adc-card-body">
        <div className="adc-skel-line w-85" />
        <div className="adc-skel-line w-60" />
        <div className="adc-skel-line w-40" />
        <div className="adc-skel-btn" />
      </div>
    </div>
  );
}

function ProductGrid({
  products = [],
  onSelect,
  loading = false,
  skeletonCount = 12,
  configuracionTienda,
}) {
  return (
    <div className="adc-grid-wrapper">
      <div className="adc-grid">
        {loading
          ? Array.from({ length: skeletonCount }).map((_, i) => (
              <ProductCardSkeleton key={`sk-${i}`} />
            ))
          : products.map((p) => (
              <ProductCard
                key={p.producto_id}
                data={p}
                configuracionTienda={configuracionTienda}
                onClick={() => onSelect(p)}
              />
            ))}
      </div>
    </div>
  );
}

export default ProductGrid;
